import React from "react";

// This will help Intake feature flag experimental or beta features
export const futureFeatureMessage = "This feature is not yet supported by Intake";

const discardChildEvents = (e) => {
    e.stopPropagation();
    e.preventDefault();
};

// This will add a tooltip to show the users this feature is for future release
// and disable the input from interactions (including stopping children from receiving focus)
export const VisibleDisabledFeature = (props) => {
    return (
        <div
            // Disable various event types for each input we'll be disabling (dates, select dropdowns, etc.)
            onFocusCapture={discardChildEvents}
            onChangeCapture={discardChildEvents}
            title={futureFeatureMessage}
            className="disable"
        >
            {props.children}
        </div>
    );
};
